import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Button from '../../../../components/elements/button';
import toast from 'react-hot-toast';
import Icon from '../../../../components/icons';
import SelectBox from '../../../../components/elements/form/selectBox';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>;
    data: any[]; // array of selected rows
    onUpdate?: () => void;
    onCancel?: () => void;
}

const ReturnStockModal: React.FC<Props> = ({ _ref, data = [], onUpdate = () => { }, onCancel = () => { } }) => {
    const [working, setWorking] = useState(false);
    const { control, handleSubmit, formState: { errors } } = useForm<any>({
        defaultValues: {
            facilityID: null,
        }
    });

    const [facilityOptions, setFacilityOptions] = useState([]);
    const facilityApi = useFacilitiesApi();
    const cycleCountAPI = useCycleCountApi();

    const getFacilityList = () => {
        facilityApi.getFacilityList(
            {},
            (resp: any) => {
                const list = (resp.facilityList || []).map((fac: any) => ({
                    label: fac.facilityName,
                    value: fac.facilityID,
                    data: fac
                }));
                setFacilityOptions(list);
            },
            (error: any) => {
                toast.error("Error loading facilities");
            }
        );
    };

    const onClose = () => {
        _ref?.current?.close();
        onCancel();
    };

    const onSubmit = (formData: any) => {
        if (!data?.length) {
            toast.error("No stock selected for return.");
            return;
        }

        setWorking(true);

        const payload = {
            stockReturnList: data.map((item: any) => ({
                partsID: item.partsID,
                //userID: item.userID,
                userID: item.pickedByID,
                addedBy: item.addedBy,
                returnQty: item.returningQty,
                facilityID: formData.facilityID?.value,
                unitID: item.unitID,
            }))
        };
        console.log("SaveStockReturn payload", payload, data)

        cycleCountAPI.SaveStockReturn(payload, (resp: any) => {
            setWorking(false);
            toast.success("Stock return saved successfully.");
            onUpdate(); // trigger parent update
        }, (error: any) => {
            setWorking(false);
            toast.error("Failed to save stock return.");
        });
    };



    useEffect(() => {
        getFacilityList();
    }, []);

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[40rem] p-0">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='flex items-center justify-between border-b border-[#8D6E63] p-4 sticky top-0 bg-white z-[1px]'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>Return Stock</p>
                        <button type="button" onClick={onClose} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3 min-h-[20rem] px-4'>

                        <Controller
                            name="facilityID"
                            control={control}
                            rules={{ required: "Facility is required" }}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label="Select Facility"
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder="Choose Facility"
                                    options={facilityOptions}
                                    error={errors.facilityID?.message as any}
                                />
                            )}
                        />
                    </div>

                    <div className='flex justify-end gap-2 border-t border-[#8D6E63] pt-2 sticky bottom-0 bg-white z-[1px] px-4 pb-4'>
                        <Button type="button" theme='secondary' onClick={() => {
                            _ref?.current?.close();
                            onClose();
                        }}>Cancel</Button>
                        <Button type="submit" working={working} >Save</Button>
                    </div>

                </form>

            </div>
            <form method="dialog" className="modal-backdrop" onClick={onClose}>

            </form>
        </dialog>
    );
};

export default ReturnStockModal;